import React from 'react';
import DocStack from './DocStack';
import http from '../../../utils/http';
import { getLocatDate } from 'utils/converter';
import events from '../../../utils/evemts';

class DocStackContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      docs: [],
      docId: 0,
      targetDocId: 0,
      selectedDoc: {},
      docData: [],
      mainDocData: {},
      searchOptions: {
        start: getLocatDate('DD MMM YYYY'),
        end: getLocatDate('DD MMM YYYY'),
        verified: false,
        identity: 'all',
        awb: ''
      },
      currentPage: 1,
      requestId: null,
      undoStack: [],
      newFileName: '',
      editedName: '',
      editingDocId: null
    };
  }

  toggleOpen = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  handleEvent = (msg) => {
    console.log('🚀 ~ DocStackContainer ~ msg:', msg);

    if (!msg.data) return;

    this.setState((prevState) => {
      const docs = [...prevState.docs];
      let index, delIndex;
      switch (msg.action) {
        case 'add':
          return { docs: [...docs, msg.data] };

        case 'update':
          index = docs.findIndex(c => c.id === msg.data.id);
          if (index > -1) {
            docs[index] = { ...msg.data };
            return { docs };
          } else {
            this.fetchDocs();
            return null;
          }

        case 'delete':
          delIndex = docs.findIndex(c => c.id == msg.data.id);
          if (delIndex > -1) {
            docs.splice(delIndex, 1);
            return { docs };
          }
          return null;

        default:
          return null;
      }
    });
  };


  selectDoc = (doc) => {
    this.setState({
      docData: [doc],
      docId: doc.id,
      currentPage: 1,
      pageNo: 1
    });
  };

  componentDidMount() {
    const savedUndoStack = JSON.parse(localStorage.getItem('undoStack') || '[]');
    this.setState({ undoStack: savedUndoStack });
    // Any initialization if needed
    this.fetchDocs();
    this.eventSource = events('docs', 'awb_stack');
    this.eventSource.onmessage = ({ type, data }) => {
      if (type == 'message') {
        const msg = JSON.parse(data || '{}');
        this.handleEvent(msg);
      }
    };
  }

  handleProcessStack = () => {
    const { requestId } = this.state;
    if (!requestId) return;
    http.post('/doc_stack/process', { requestId }).then(({ data }) => {
      if (data.status === 'success') {
        localStorage.removeItem('undoStack');
        this.props.history.push('/docs_stream');
      }
    });
  };

  handleEditName = () => {
    const { editingDocId, editedName } = this.state;
    if (!editingDocId || !editedName) return;

    http.put(`/doc_stack/edit_name/${editingDocId}`, { awb_no: editedName }).then(({ data }) => {
      if (data.status === 'success') {
        this.setState({
          editingDocId: null,
          editedName: ''
        });
        // this.fetchDocs();
      }
    });
  };

  fetchDocs = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const requestId = queryParams.get('requestId');
    let query = `requestId=${requestId}&type=awb_stack`;

    let url = `/doc_stack?${query}`;
    http.get(url, this.state.searchOptions)
      .then((response) => {
        // handle success
        this.setState({
          docs: response.data.data?.docs || response.data.data,
          mainDocData: response.data.data?.mainDoc || {},
          requestId
        }, () => {
        });
      }).catch(() => {
        this.setState({ docs: [] }, () => {
          // this.filterDocs();
        });
      });
  };

  selectFileDoc(docId) {
    this.setState({ targetDocId: docId });
  }

  confirmSelectFileDoc = (type) => {
    const { targetDocId, docId, currentPage, undoStack, newFileName } = this.state;
    http.post('/doc_stack/file', {
      docId,
      targetDocId,
      pageNo: currentPage,
      type,
      newFileName
    }).then(({ data }) => {
      if (data.status === 'success') {
        const actionId = data.data?.actionId;
        if (actionId) {
          const newUndoStack = type === 'split' ? [...undoStack, actionId] : null;
          console.log('🚀 ~ DocStackContainer ~ newUndoStack:', newUndoStack);
          this.setState({
            undoStack: newUndoStack,
            targetDocId: 0,
            docId: 0,
            docData: [],
            newFileName: ''
          }, () => {
            if (newUndoStack) {
              localStorage.setItem('undoStack', JSON.stringify(newUndoStack));
            }
          });
        }
        // this.fetchDocs();

      }
    });
  };

  handleUndo = () => {
    const { undoStack } = this.state;
    if (undoStack && undoStack.length === 0) return;

    const lastActionId = undoStack[undoStack.length - 1];

    http.post('/doc_stack/undo', { actionId: lastActionId }).then(({ data }) => {
      if (data.status === 'success') {
        // Remove last actionId from the stack
        const newStack = [...undoStack];
        newStack.pop();
        this.setState({ undoStack: newStack }, () => {
          localStorage.setItem('undoStack', JSON.stringify(newStack));
        });
        // this.fetchDocs();
      }
    });
  };

  setEditingDocId = (id) => {
    const doc = this.state.docs.find(d => d.id === id);
    this.setState({
      editingDocId: id,
      editedName: doc ? doc.name : ''
    });
  };

  onChangeDoc = (e) => {

    const isFile = e.target.name === 'file';
    const value = isFile ? e.target.files[0] : e.target.value;

    const newFields = {
      ...this.state.fields,
      [e.target.name]: value,
    };

    this.setState({ fields: newFields }, () => {
      if (isFile) {
        // Automatically upload when file is selected
        // if (this.validateDoc && this.validateDoc()) {
        const formdata = new FormData();
        Object.keys(newFields).forEach((key) => {
          formdata.append(key, newFields[key]);
        });

        http.post('/doc_stack/add', formdata, { headers: { 'Content-Type': 'multipart/form-data' } }).then(({ data }) => {
          if (data.status === 'success') {
            this.setState({ fields: {} });
          }
        });
      }
      // }
    });
  };

  clearDoc = () => {
    this.setState({
      docId: 0,
      selectedDoc: {}
    });
  };

  deleteDoc = (id) => {
    // this.props.setDelete({
    //   modal: false,
    //   anchorEl: null
    // });
    http.delete(`/doc_stack/${id}`).then(({ data }) => {
      if (data.status === 'success') {
        const actionId = data.data?.actionId;
        if (actionId) {
          const newUndoStack = [...this.state.undoStack, actionId];
          this.setState({ undoStack: newUndoStack }, () => {
            localStorage.setItem('undoStack', JSON.stringify(newUndoStack));
          });
        }

      }
    });
  };

  componentWillUnmount() {
    localStorage.removeItem('undoStack');
  }

  handlePageChange = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  handleBeforeUnload = () => {
    localStorage.removeItem('undoStack');
  };

  // Removed addDoc, upload now handled automatically in onChangeDoc

  render() {
    return (
      <DocStack
        open={this.state.open}
        toggleOpen={this.toggleOpen}
        onChange={this.onChangeDoc}
        docs={this.state.docs}
        docData={this.state.docData}
        selectDoc={this.selectDoc}
        currentPage={this.state.currentPage}
        handlePageChange={this.handlePageChange}
        changeTargetDoc={(docId) => this.selectFileDoc(docId)}
        targetDocId={this.state.targetDocId}
        confirmFiling={this.confirmSelectFileDoc}
        docId={this.state.docId}
        handleDelete={this.deleteDoc}
        handleProcessStack={this.handleProcessStack}
        mainDocData={this.state.mainDocData}
        undoStack={this.state.undoStack}
        handleUndo={this.handleUndo}
        newFileName={this.state.newFileName}
        editedName={this.state.editedName}
        setNewFileName={(name) => this.setState({ newFileName: name })}
        setEditedName={(name) => this.setState({ editedName: name })}
        editingDocId={this.state.editingDocId}
        setEditingDocId={(id) => this.setEditingDocId(id)}
        handleEditName={this.handleEditName}
      />
    );
  }
}

export default DocStackContainer;